import { Link } from "react-router-dom";

const stats = [
  { value: "12,000+", label: "影视资源" },
  { value: "3 大", label: "内容频道" },
  { value: "每日", label: "持续更新" },
  { value: "全端", label: "便捷浏览" },
];

export default function SiteIntro() {
  return (
    <section className="mx-auto w-full max-w-[1440px] px-4 py-12 md:px-8 md:py-16">
      <div className="grid grid-cols-1 items-center gap-10 lg:grid-cols-2">
        <div>
          <span className="inline-flex items-center gap-2 rounded-full bg-primary-100 px-3 py-1 text-xs font-medium text-primary-700">
            <i className="ri-information-line"></i>
            关于粉色视频
          </span>
          <h2 className="mt-4 text-2xl font-black leading-snug text-foreground-950 md:text-3xl">
            一个更懂你的
            <span className="text-primary-500">视频内容聚合平台</span>
          </h2>
          <p className="mt-4 text-sm leading-relaxed text-foreground-600 md:text-base">
            粉色视频专注于聚合电影、电视剧、综艺等多元化视频内容，通过清晰的内容分类、
            智能的筛选排序与即时的关键词搜索，帮助你在海量资源中快速找到想看的作品。
          </p>
          <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-base">
            我们坚持简洁大气的视觉表达与直观高效的操作体验，让浏览、发现与收藏都变得轻松自然。
            每一次打开，都是一场属于你的视觉娱乐之旅。
          </p>
          <div className="mt-6 flex flex-wrap items-center gap-3">
            <Link
              to="/about"
              className="flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
            >
              了解我们
              <i className="ri-arrow-right-line"></i>
            </Link>
            <Link
              to="/category/variety"
              className="flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-md border border-background-300 px-6 py-3 text-sm font-semibold text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-600"
            >
              浏览综艺
            </Link>
          </div>
        </div>

        <div className="grid grid-cols-2 gap-4">
          {stats.map((s, i) => (
            <div
              key={s.label}
              className={`rounded-lg p-6 ${
                i % 2 === 0 ? "bg-background-100" : "bg-secondary-50"
              }`}
            >
              <p className="text-2xl font-black text-primary-500 md:text-3xl">{s.value}</p>
              <p className="mt-2 text-sm text-foreground-600">{s.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}